import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { TypographyProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardTypography = dynamic(
  () => import("./DashboardTypographySsr").then((mod) => mod.DashboardTypographySsr),
  { ssr: false }
);

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardTypography = forwardRef<HTMLParagraphElement, TypographyProps>((props, ref) => (
  <DynamicDashboardTypography {...props} forwardedRef={ref} />
));

DashboardTypography.displayName = "DashboardTypography";
